/** @format */

import React from "react";
import { Order, User } from "../../../services";
import { toast } from "react-toastify";

const OrdersParsingData = async (orderId, setStateFunctions) => {
  const {
    setLoadingGet,
    setOrderData,
    setCargoDetails,
  } = setStateFunctions;

  setLoadingGet(true);

  try {
    const orderPromise = Order.getOrderById(orderId);
    const cargoPromise = orderPromise.then((order) => Order.getCargo(order.data.cargoId));
   
    const [
      orderData,
      cargoData,
    ] = await Promise.all([orderPromise, cargoPromise]);

    const order = orderData.data;
    setOrderData(order);

    setCargoDetails(cargoData.status === 200 ? cargoData.data : {});
  } catch (error) {
    console.error(error);
    toast.error("Произошла ошибка, попробуйте позже");
  } finally {
    setLoadingGet(false);
  }
};

export default OrdersParsingData;
